// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"26decf580e1951e769bc","883":"7a4778cfc4a5c25b098c"}[chunkId] + ".js";
};